import { create } from "zustand";

/**
 * Quota Store
 * Quản lý state cho quota exceeded và upgrade modal
 */
const useQuotaStore = create((set, get) => ({
  // State
  isQuotaExceeded: false,
  quotaInfo: null, // { feature_name, limit, message }
  showUpgradeModal: false,

  // Actions
  /**
   * Set quota exceeded state và show upgrade modal
   * @param {Object} quotaInfo - Thông tin quota { feature_name, limit, message }
   */
  setQuotaExceeded: (quotaInfo) => {
    set({
      isQuotaExceeded: true,
      quotaInfo,
      showUpgradeModal: true,
    });
  },

  /**
   * Clear quota exceeded state
   */
  clearQuotaExceeded: () => {
    set({
      isQuotaExceeded: false,
      quotaInfo: null,
    });
  },

  /**
   * Show/hide upgrade modal
   */
  setShowUpgradeModal: (show) => {
    set({ showUpgradeModal: show });
  },

  /**
   * Close upgrade modal and clear quota state
   */
  closeUpgradeModal: () => {
    set({
      showUpgradeModal: false,
      isQuotaExceeded: false,
      quotaInfo: null,
    });
  },
}));

export default useQuotaStore;
